import { toast } from "react-toastify";
import axiosInstance from "../../../axiosSetup";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getEmailTemplate = createAsyncThunk(
    'emailTemplate/getEmailTemplate',
    async (payload: {emailTemplateId: string}) => {
      try {
        const response =await axiosInstance.get(
            `/api/edo-rest-v2/v2/emailTemplate?emailTemplateId=${payload.emailTemplateId}`
          );
        if (!response || !response.data) {
          console.error('Invalid response');
        }
        return { data:response.data.data,status:response.data.status };
      } catch (error) {
        console.error('Error: getEmailTemplate in emailTemplateActions.ts', error);
        toast.error('Unable to get email template details');
      }
    }
  );

  export const updateEmailTemplate = createAsyncThunk(
    'emailTemplate/updateEmailTemplate',
    async (payload: any) => {
      try {
        const response =await axiosInstance.post(
          '/api/edo-rest-v2/v2/emailTemplate/update',
          payload
        );
        if (!response || !response.data) {
          console.error('Invalid response');
        }
        if(response.data.status === 'success'){
          toast.success(response.data.message);
        }
        else{
          toast.error(response.data.message??"Failed to update email template");
        }
        return {status:response.data.status};
      } catch (error) {
        toast.error((error as any).response.data.message??"Failed to update email template");
        console.error('Error: updateEmailTemplate in emailTemplateActions.ts', error);
      }
    }
  );